import KpiLoaders from "./KpiLoaders";
import { cn } from "../../../utils";

type TRoleCardLoaderProps = {
  numberOfLoaders: number;
  className?: string;
};

export default function RoleCardLoader({
  numberOfLoaders,
  className,
}: TRoleCardLoaderProps) {
  return (
    <div
      data-testid="role-card-grid"
      className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
    >
      {Array.from({ length: numberOfLoaders }, (_, index) => (
        <div
          data-testid="role-card-loader"
          key={index}
          className={cn(
            "rounded-lg border border-gray-200 bg-white p-4 shadow-sm dark:border-gray-700 dark:bg-gray-800",
            className,
          )}
        >
          {/* Header */}
          <div className="mb-3 flex items-center justify-between">
            <KpiLoaders numberOfLoaders={1} className="h-4 w-24 rounded" />
            <KpiLoaders numberOfLoaders={1} className="h-5 w-12 rounded-full" />
          </div>

          {/* Subtitle */}
          <KpiLoaders numberOfLoaders={1} className="mb-1 h-3 w-32 rounded" />
          <KpiLoaders numberOfLoaders={1} className="mb-3 h-3 w-40 rounded" />

          {/* Permissions & Assignments */}
          <div className="mb-4 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <KpiLoaders
                numberOfLoaders={1}
                className="h-6 w-6 rounded-full"
              />
              <KpiLoaders numberOfLoaders={1} className="h-3 w-16 rounded" />
            </div>

            <div className="flex items-center gap-2">
              <KpiLoaders
                numberOfLoaders={1}
                className="h-6 w-6 rounded-full"
              />
              <KpiLoaders numberOfLoaders={1} className="h-3 w-16 rounded" />
            </div>
          </div>

          {/* Date */}
          <div className="mb-3 flex items-center gap-2">
            <KpiLoaders numberOfLoaders={1} className="h-4 w-4 rounded" />
            <KpiLoaders numberOfLoaders={1} className="h-3 w-28 rounded" />
          </div>

          {/* Footer */}
          <div className="mt-auto flex justify-end gap-2">
            <KpiLoaders numberOfLoaders={1} className="h-6 w-6 rounded" />
            <KpiLoaders numberOfLoaders={1} className="h-6 w-6 rounded" />
            <KpiLoaders numberOfLoaders={1} className="h-6 w-6 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}
